import { __rest } from 'tslib';
import React from 'react';
import LittleArrowIcon from '../Icons/LittleArrowIcon.mjs';
import { IconWrapper, StyledCategoryLink, StyledCategoryText } from './CategoryTitle.styles.mjs';
import { useTheme } from 'styled-components';

const CategoryTitle = (_a) => {
    var { children, fillArrow, withMarker, withArrow, uppercased } = _a, styleProps = __rest(_a, ["children", "fillArrow", "withMarker", "withArrow", "uppercased"]);
    const theme = useTheme();
    const content = (React.createElement(React.Fragment, null,
        children,
        withArrow && (React.createElement(IconWrapper, { uppercased: uppercased },
            React.createElement(LittleArrowIcon, { fill: fillArrow !== null && fillArrow !== void 0 ? fillArrow : theme.colors.categoryTextColor })))));
    if ('href' in styleProps) {
        return (React.createElement(StyledCategoryLink, Object.assign({ withMarker: withMarker, withArrow: withArrow, uppercased: uppercased }, styleProps), content));
    }
    return (React.createElement(StyledCategoryText, Object.assign({ withMarker: withMarker, withArrow: withArrow, uppercased: uppercased }, styleProps), content));
};

export { CategoryTitle as default };
//# sourceMappingURL=CategoryTitle.mjs.map
